<template>
  <div class="join-us">
    <div class="big-picture__one">
        <img :src="contentImg.imgPath"/>
    </div>
    <div class="fy-introduction" v-if="!IsMobile">
      <div class="fy-drawer">
        <div class="fy-drawer__logo">
          <img :src="ppjsIcon" />
        </div>
        <div class="fy-drawer__text">
        </div>
        <div class="fy-drawer__bottom">
          <img :src="drawerBottomIcon" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { IsMobile } from "@/utils";
import ppjsIcon from "@/assets/lxwm—icon.png";
import drawerBottomIcon from "@/assets/drawer-bottom-icon@3x.png";
export default Vue.extend({
  name: "ContactUs",
  data() {
    return {
      contentImg: {},
      IsMobile,
      ppjsIcon,
      drawerBottomIcon,
    };
  },
  created() {
    this.geContentImg();
  },
  methods: {  
    geContentImg() {
      this.$https.get("/api/publicresources/getPublicResources", {params:{
        type: 'contact',
        isMobile: IsMobile ? 2 : 1
      }}).then((res) => {
        this.contentImg = res.data[0];
      });
    },
  },
});
</script>